import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import * as Util from '../../../util';
import RequestType from '../RequestType';
import { connectToUser } from '../../User/containers/UserDataStore';

const RequestsContext = React.createContext();

export const useRequests = () => React.useContext(RequestsContext);

const name = 'requestsDataStore';

export const connectToRequests = makeConnectTo(RequestsContext, name);

class RequestsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		requests: [],
		selectedMenuOption: RequestType.All.key,
		isLoading: true,
	};

	render() {
		const requestsDataStore = this.getStore();
		return (
			<RequestsContext.Provider value={requestsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(requestsDataStore)
					: this.props.children}
			</RequestsContext.Provider>
		);
	}

	componentDidMount() {
		const { isAnonymous } = this.props.userDataStore;
		if (!isAnonymous()) {
			this.fetchRequests();
		} else {
			this.setState({ isLoading: false });
		}
	}

	componentWillUnmount() {
		if (this.requestsFetch && this.requestsFetch.cancel) {
			this.requestsFetch.cancel();
		}
		if (this.conversationsFetch && this.conversationsFetch.cancel) {
			this.conversationsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshRequests(),
		fetchConversationStatus: () => this.fetchConversationStatus(),
		setSelectedMenuOption: selectedMenuOption =>
			this.setSelectedMenuOption(selectedMenuOption),
	});

	refreshRequests = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchRequests();
		return this.requestsFetch.promise;
	};

	fetchRequests = () => {
		const request = api.cancelableGet(`/api/v1/me/requests`);
		request.promise.then(this.cacheApiResponse);
		this.requestsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const requests = apiResponse && Util.createTitleObject(apiResponse);
		this.setState({
			requests,
			isLoading: false,
			skus: this.getSkus(requests),
		});
		this.fetchConversationStatus();
	};

	getSkus = titles => {
		return titles && titles.map(item => item.sku);
	};

	fetchConversationStatus = () => {
		const { skus } = this.state;
		const communityId = 0;

		const request = api.cancelablePost(
			`/api/v1/conversations/${communityId}/titles`,
			skus,
		);
		request.promise.then(this.cacheConversationApiResponse);
		this.conversationsFetch = request;
	};

	cacheConversationApiResponse = apiResponse => {
		this.setState({
			conversations: apiResponse,
			areConversationsLoading: false,
		});
	};

	setSelectedMenuOption = selectedMenuOption => {
		this.setState({ selectedMenuOption });
	};
}

export default connectToUser(RequestsDataStore);
